/**
 * inviteApi: client for the shareable join-link endpoints (Phase 1 of #26).
 *
 * Follows the project's `useXApi()` convention: wraps the authenticated axios
 * instance (which attaches the Firebase token and prepends the active tenant's
 * basePath to relative `/api` URLs) and returns a memoised set of methods.
 */
import { useMemo } from 'react';

import { useAuthenticatedAxios } from './axiosInstance';

export const useInviteApi = () => {
    const api = useAuthenticatedAxios();

    return useMemo(
        () => ({
            // Generate (or reuse) the current member's invite token for the
            // active ecosystem. The basePath interceptor scopes the request to
            // the tenant, so the server resolves the ecosystem from context.
            // Returns { token, expiresAt }.
            generateInvite: async () => {
                const response = await api.post('/api/invites');
                return response.data;
            },

            // Resolve an invite token (Phase 2, #171) for the landing banner.
            // Public endpoint — works for signed-out recipients. Returns
            // { valid, ecosystem: { name, slug }, inviter: { name } } or
            // { valid: false, reason }.
            resolveInvite: async (token) => {
                const response = await api.get(
                    `/api/invites/${encodeURIComponent(token)}`
                );
                return response.data;
            },
        }),
        [api]
    );
};

export default useInviteApi;
